<script setup lang="ts">
import { defineComponent, reactive, watch } from "vue";
import { useRoute } from "vue-router";
import stateStore from "../../utils/store";
import config from "../../app.config.json"
import { useUserStore } from "@/stores/userStore";

const userStore = useUserStore();
const stateStoreInstance = stateStore;
const route = useRoute();

// Abaixo de 1200px o menu é um overlay (classe "active" = visível).
// Ao navegar, fecha o menu para não cobrir o conteúdo no celular/tablet.
watch(() => route.fullPath, () => {
  if (window.innerWidth < 1200 && stateStoreInstance.open) {
    stateStoreInstance.open = false;
  }
});

</script>

<template>
  <div :class="[
    'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition d-print-none',
    { active: stateStoreInstance.open },
  ]" id="sidebar-area">
    <div class="logo position-absolute start-0 end-0 top-0 bg-black d-print-none">
      <router-link to="/" class="d-flex align-items-center text-white text-decoration-none">
        <img src="../../assets/images/favicon.png" alt="logo-icon" />
        <span class="fw-bold ms-10">{{ config.empresa }}</span>
      </router-link>
      <div class="border-bottom"></div>
      <button class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
        @click="stateStoreInstance.onChange">
        <i class="ph-duotone ph-caret-double-right"></i>
      </button>
    </div>
    <div class="sidebar-menu">
      <ul class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion" id="sidebarNavAccordion">
        <li class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <a href="#" class="accordion-button rounded-0 shadow-none bg-transparent d-block" data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseOne" aria-expanded="true" aria-controls="sidebarCollapseOne">
            <i class="flaticon-more-1"></i>
            <span class="title">Menu</span>
          </a>
          <div id="sidebarCollapseOne" class="accordion-collapse collapse show" data-bs-parent="#sidebarNavAccordion">
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('usuarios')">
                  <router-link to="/usuarios" class="sidebar-sub-menu-link">
                    Usuários
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('planos')">
                  <router-link to="/planos" class="sidebar-sub-menu-link">
                    Planos
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('clientes')">
                  <router-link to="/clientes" class="sidebar-sub-menu-link">
                    Clientes
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('empresas')">
                  <router-link to="/empresas" class="sidebar-sub-menu-link">
                    Empresas
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('contratos')">
                  <router-link to="/contratos" class="sidebar-sub-menu-link">
                    Contratos
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('parceiros')">
                  <router-link to="/parceiros" class="sidebar-sub-menu-link">
                    Parceiros
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('vouchers')">
                  <router-link to="/vouchers" class="sidebar-sub-menu-link">
                    Vouchers
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('titulares')">
                  <router-link to="/titulares" class="sidebar-sub-menu-link">
                    Diário de ativos
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('contasReceber')">
                  <router-link to="/contasReceber" class="sidebar-sub-menu-link">
                    Contas a Receber
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('boletos')">
                  <router-link to="/boletos" class="sidebar-sub-menu-link">
                    Cobrança
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('parametros')">
                  <router-link to="/parametros" class="sidebar-sub-menu-link">
                    Parâmetros
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="userStore.tipoId === 1">
                  <router-link to="/permissoes" class="sidebar-sub-menu-link">
                    Permissões
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="userStore.tipoId === 1">
                  <router-link to="/logs" class="sidebar-sub-menu-link">
                    Logs
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item">
                  <router-link to="/versoes" class="sidebar-sub-menu-link">
                    Versões
                  </router-link>
                </li>

              </ul>
            </div>
          </div>
        </li>

        <li class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <a href="#" class="accordion-button rounded-0 shadow-none bg-transparent d-block" data-bs-toggle="collapse"
            data-bs-target="#sideRelatorios" aria-expanded="true" aria-controls="sideRelatorios">
            <i class="flaticon-more-1"></i>
            <span class="title">Relatórios</span>
          </a>
          <div id="sideRelatorios" class="accordion-collapse collapse show" data-bs-parent="#sidebarNavAccordion">
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('relatorios')">
                  <router-link to="/relatorios/mensalidades" class="sidebar-sub-menu-link">
                    Mensalidades
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('relatorios')">
                  <router-link to="/relatorios/clientes" class="sidebar-sub-menu-link">
                    Clientes
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('relatorios')">
                  <router-link to="/relatorios/clientescontrato" class="sidebar-sub-menu-link">
                    Clientes X Contrato
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="userStore.hasPermissao('relatorios')">
                  <router-link to="/relatorios/clientesdependentes" class="sidebar-sub-menu-link">
                    Clientes X Dependentes
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

      </ul>
    </div>
  </div>
</template>
